import React from 'react'
import { connect } from 'react-redux'
import { withStyles, Typography, Button } from '@material-ui/core'

import { getAppPDV } from '../../store/app/selectors'
import { computeUrl } from '../atoms/BackButton'

const styles = theme => ({
  root: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    ...theme.mixins.gutters(),
    marginBottom: theme.spacing.unit * 4
  }
})

const ErrorPageBase = ({ classes, pdvId }) => {
  const url = 'http://' + computeUrl(`${window.location.host}/`, pdvId)
  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <Typography variant="h5">Ooops!</Typography>
        <Typography variant="body1">
          C'è stato un errore con la tua prenotazione, riprova più tardi.
        </Typography>
      </div>
      <Button variant="contained" onClick={() => {
        window.location.href = url
      }}>
        Torna all'inizio
      </Button>
    </div>
  )
}

export const ErrorPage = withStyles(styles)(ErrorPageBase)

const mapStateToProps = state => ({
  pdvId: getAppPDV(state)
})

export const LinkedErrorPage = connect(mapStateToProps)(ErrorPage)
